import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    className?: string;
    href: string;
    title: string;
    newTab?: boolean;
    onClick?: () => void;
}

const BaseLinkButton = ({
    className,
    href,
    newTab,
    onClick,
    title,
}: IProps) => (
    <a
        className={className}
        href={href}
        rel="noreferrer"
        target={newTab ? '_blank' : '_parent'}
        onClick={onClick}
    >
        {title}
    </a>
);

export const LinkButton = styled(BaseLinkButton)`
    appearance: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.white};
    background-color: ${colors.black};
    border-radius: 3px;
    font-size: 1rem;
    font-weight: 700;
    padding: 8px 24px;
    border: 2px solid ${colors.black};
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        border: 2px solid ${colors.buttonHover};
    }
`;
